import { BaseValidator } from './BaseValidator';
import { BaseDisplayer } from '../Displayers/BaseDisplayer';
import { ParseResult, IParseResult, ValueType } from '../FormatterTypes';
import { parseParamList } from '../Utils/ParamUtils';
import {
  displayValue,
  isParseError,
  isParseWarning,
} from '../Utils/ValueUtils';

class TEDValidateNumber extends BaseValidator {
  public static getInstance(): BaseValidator {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: BaseValidator;

  defaultParams(): string {
    return 'MinValue="";MaxValue="";MinRecommendedValue="";MaxRecommendedValue=""';
  }

  validate(value: ValueType, params?: string): IParseResult {
    const par: Record<string, string> = parseParamList(params ?? '');
    let result = ParseResult.OK;
    if (typeof value == 'number') {
      const minval = par['MinValue'] != null ? Number(par['MinValue']) : null;
      const maxval = par['MaxValue'] != null ? Number(par['MaxValue']) : null;
      if (minval != null && value < minval) {
        if (maxval != null) {
          result = ParseResult.ERROR_BELOWRANGE;
        } else {
          result = ParseResult.ERROR_BELOWMIN;
        }
      }
      if (maxval != null && value > maxval) {
        if (minval != null) {
          result = ParseResult.ERROR_ABOVERANGE;
        } else {
          result = ParseResult.ERROR_ABOVEMAX;
        }
      }

      if (result === ParseResult.OK) {
        const minRecommended = par['MinRecommendedValue'] != null ? Number(par['MinRecommendedValue']) : null;
        const maxRecommended = par['MaxRecommendedValue'] != null ? Number(par['MaxRecommendedValue']) : null;

        if (minRecommended != null && value < minRecommended) {
          if (maxRecommended != null) {
            result = ParseResult.WARNING_BELOWRANGE;
          } else {
            result = ParseResult.WARNING_BELOWMIN;
          }
        }

        if (maxRecommended != null && value > maxRecommended) {
          if (minRecommended != null) {
            result = ParseResult.WARNING_ABOVERANGE;
          } else {
            result = ParseResult.WARNING_ABOVEMAX;
          }
        }
      }
    }

    return {
      value: value,
      result: result,
    };
  }

  errorMessage(
    value: ValueType,
    parseResult: IParseResult,
    displayer: BaseDisplayer,
    params: string = '',
    displayerParams: string = '',
    caption: string = '',
    preFix: string = ''
  ): string {
    let msg: string = super.errorMessage(
      value,
      parseResult,
      displayer,
      params,
      displayerParams,
      caption
    );
    const par: Record<string, string> = parseParamList(params ?? '');

    if (isParseError(parseResult.result)) {
      switch (parseResult.result) {
        case ParseResult.ERROR_BELOWMIN:
          msg += ` Värde måste vara ${displayValue(
            par['MinValue'],
            displayer,
            displayerParams
          )} eller mer.`;
          break;
        case ParseResult.ERROR_ABOVEMAX:
          msg += ` Värde måste vara ${displayValue(
            par['MaxValue'],
            displayer,
            displayerParams
          )} eller mindre.`;
          break;
        case ParseResult.ERROR_BELOWRANGE:
        case ParseResult.ERROR_ABOVERANGE:
          msg += ` Värde måste vara mellan ${displayValue(
            par['MinValue'],
            displayer,
            displayerParams
          )} och ${displayValue(par['MaxValue'], displayer, displayerParams)}.`;
          break;
      }
    } else if (isParseWarning(parseResult.result)) {
      switch (parseResult.result) {
        case ParseResult.WARNING_BELOWMIN:
          msg += ` Värde borde vara ${displayValue(
            par['MinRecommendedValue'],
            displayer,
            displayerParams
          )} eller mer.`;
          break;
        case ParseResult.WARNING_ABOVEMAX:
          msg += ` Värde borde vara ${displayValue(
            par['MaxRecommendedValue'],
            displayer,
            displayerParams
          )} eller mindre.`;
          break;
        case ParseResult.WARNING_BELOWRANGE:
        case ParseResult.WARNING_ABOVERANGE:
          msg += ` Värde borde vara mellan ${displayValue(
            par['MinRecommendedValue'],
            displayer,
            displayerParams
          )} och ${displayValue(
            par['MaxRecommendedValue'],
            displayer,
            displayerParams
          )}.`;
          break;
      }
    }
    return msg;
  }
}

export { TEDValidateNumber };
